import { render, staticRenderFns } from "./agentForm2.vue?vue&type=template&id=23763b32&scoped=true&"
import script from "./agentForm2.vue?vue&type=script&lang=js&"
export * from "./agentForm2.vue?vue&type=script&lang=js&"
import style0 from "./agentForm2.vue?vue&type=style&index=0&id=23763b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23763b32",
  null
  
)

export default component.exports